export default "__VITE_ASSET__Ce5Df25S__"